<template>
	<div class="ui-label-switch-wrapper" @click="handleClick">
		<span>
			<i v-if="icon" :class="['fas', icon]" />
			{{label}}
		</span>
		<div class="ui-label-switch">
			<input v-model="localValue" type="checkbox">
			<div class="ui-label-switch-slider">
				<div class="ui-label-switch-knob"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: Boolean
		},

		label: {
			type: String,
			default: ''
		},

		icon: {
			type: String,
			default: ''
		}
	},

	data: () => ({
		localValue: null
	}),

	watch: {
		value(to) {
			this.localValue = to;
		},

		localValue(to) {
			this.$emit('input', to);
		}
	},

	created() {
		this.localValue = this.value;
	},

	methods: {
		handleClick() {
			this.localValue = !this.localValue;
			this.$emit('click', this.localValue);
		}
	}
};
</script>

<style lang="scss">
.ui-label-switch-wrapper {
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	padding: 5px 10px;
	border-radius: 20px;
	background-color: lighten(#363a41, 20%);
	border: 1px solid darken(#363a41, 1%);
	box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px 0px inset;

	i {
		color: white;
	}

	span {
		font-size: 12px;
		letter-spacing: 0.05rem;
		margin-right: 5px;
	}
}
.ui-label-switch {
	display: block;
	width: 45px;
	height: 25px;
	cursor: pointer;
	position: relative;
}

.ui-label-switch input[type="checkbox"] {
	display: none;
}

.ui-label-switch input[type="checkbox"]:checked+.ui-label-switch-slider {
	background-color: #44cc66;
}

.ui-label-switch-slider {
	background-color: #ccc;
	position: absolute;
	border-radius: 100px;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	-webkit-transition: all 300ms ease;
	transition: all 300ms ease;
}

.ui-label-switch-knob {
	position: absolute;
	-webkit-transition: all 300ms ease;
	transition: all 300ms ease;
}

.ui-label-switch input[type="checkbox"]:checked+.ui-label-switch-slider .ui-label-switch-knob {
	left: calc(100% - 19px - 3px);
}

.ui-label-switch-knob {
	width: 25px;
	height: 25px;
	border-radius: 50%;
	left: 0;
	top: 0;
	background-color: #fff;
	//-webkit-box-shadow: 0 2px 6px rgba(153, 153, 153, 0.75);
	//box-shadow: 0 2px 6px rgba(153, 153, 153, 0.75);
}
</style>
